import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WindowService } from 'src/shared/providers/window.service';

@Component({
  templateUrl: 'add-agreement.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddAgreementPage implements OnInit {
  private navCtrl = inject(CustomNavController);
  private rightSidePanelService = inject(RightSidePanelService);
  private storage = inject(TidyStorage);
  private fb = inject(UntypedFormBuilder);

  readonly windowService = inject(WindowService);

  form: UntypedFormGroup;
  submitted = false;
  isRightSideContent = true;
  loaded = false;
  errorMessage: string;
  saveAction = () => this.save();

  constructor() {
    this.form = this.fb.group({
      agreementName: ['', Validators.required],
    });
  }

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    if (this.isRightSideContent) {
      this.rightSidePanelService.setDialogPageTitle('Add Agreement');
    }
    this.loaded = true;
  }

  async save() {
    this.submitted = true;
    if (!this.form.valid) {return;}
    try {
      if (this.isRightSideContent) {
        await this.storage.save('shouldReloadPageAfterClosingSideRail', true);
        this.rightSidePanelService.closeRightSidePanel();
      } else {
        this.navCtrl.navigateBack('compliance');
      }
    } catch (err) {
      this.errorMessage = (err.error?.message) || err.message;
    }
  }
}
